import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ProductoService } from '../../../services/riesgo-credito/riesgos/producto.service';
import { SucursalService } from '../../../services/riesgo-credito/riesgos/sucursal.service';
import { ZonaService } from '../../../services/riesgo-credito/riesgos/zona.service';
import { zonaEntity, productoEntity, sucursalEntity, sectorEntity, asesorEntity } from '../entities_riesgos/entities_riesgos';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { SectorService } from '../../../services/riesgo-credito/riesgos/sector.service';
import { CapitalizePipe } from '../../../components/pipes/capitalize.pipe';
import { AsesorService } from '../../../services/riesgo-credito/riesgos/asesor.service';

@Component({
  selector: 'app-menu-perspectivas',
  templateUrl: './menu-perspectivas.component.html',
  styleUrl: './menu-perspectivas.component.css'
})
export class MenuPerspectivasComponent {
  public idInstitucion;
  zona = new zonaEntity;
  producto = new productoEntity;
  sucursal = new sucursalEntity;
  sector = new sectorEntity;
  asesor = new asesorEntity;
  dataZona: any [] = [];
  dataSucursal: any [] = [];
  dataProducto: any [] = [];
  dataMetodologia = [{nombre: "Grupal",prod: []},
                      {nombre: "Individual",prod: []}, 
                      {nombre: "Otros",prod: []}];
  sectors: any[] = [];
  dataAsesor: any [] = [];
  dataAsesorFiltrados: any [] = [];

  @Input() tipo: Number;
  @Input() tablero: String;
  @ViewChild('perspectivas', { static: true }) public perspectivas;
  @Output() eventClick = new EventEmitter;

  constructor(
    private zonaService: ZonaService,
    private productoService: ProductoService,
    private sucursalService: SucursalService,
    private cookies: CookieService,    
    private sectorService: SectorService,
    private asesorService: AsesorService,
  ) {
    this.idInstitucion = Number(cookies.get('idInstitucion'));
    this.FuncionZona();
    this.FuncionProducto();
    this.FuncionSector();
    this.FuncionAsesor();
  }

  public filtroSelect(elem, filtro?){
    const emitFiltro = {
      filtro: filtro,
      elem: elem
    } 
    this.eventClick.emit(emitFiltro);
  }
  async FuncionZona(){
    this.zona.InstitucionId = this.idInstitucion;
    try{
      const res = await firstValueFrom(this.zonaService.getByAddUrl_Riesgo('zona',this.zona)); 
      var aux = []
      for(let i of res){
        aux.push({
          sucursales: [],
          ...i});
      }
      this.dataZona = aux;
      this.FuncionSucursal();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  async FuncionProducto(){
    this.producto.InstitucionId = this.idInstitucion;
    try{
      const res = await firstValueFrom(this.productoService.getByAddUrl_Riesgo('producto',this.producto));
      var aux = [];
      for(let i of res){
        aux.push(i);
        if(this.tipo === 1){
          switch(i.ProductoId){
            case 1018:
            case 1019:
            case 1020:
            case 1034:
            case 1036:
            case 1037:
              this.dataMetodologia[0].prod.push(i);
              break;
            case 1041:
            case 1011:
            case 1012:
            case 1013:
            case 1015:
            case 1017:
            case 1022:
            case 1024:
            case 1025:
            case 1027:
            case 1028:
            case 1030:
            case 1031:
            case 1032:
            case 1033:
            case 1039:
            case 1040:
              this.dataMetodologia[1].prod.push(i);
              break;
            default:
              this.dataMetodologia[2].prod.push(i);
              break;
          }
        }
      }
      this.dataProducto = aux; 
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async FuncionSucursal(){
    this.sucursal.InstitucionId = this.idInstitucion;
    try{
      const res = await firstValueFrom(this.sucursalService.getByAddUrl_Riesgo('sucursal',this.sucursal)); 
      let reg
      for(let i of res){
        if(this.tipo === 0){
          this.dataSucursal.push(i)
        }
        if(this.tipo === 1){
          switch(i.SucursalId){
            case 15:
            case 5:
            case 3:
              reg = this.dataZona.filter(z => z.ZonaId == 1015);
              reg[0].sucursales.push(i)
              break;
            case 7:
            case 4:
              reg = this.dataZona.filter(z => z.ZonaId == 1016);
              reg[0].sucursales.push(i)
              break;
            
            case 10:
            case 11:
            case 9:
              reg = this.dataZona.filter(z => z.ZonaId == 1018);
              reg[0].sucursales.push(i)
              break;
            case 6:
            case 8:
            case 13:
            case 2:
            case 16:
              reg = this.dataZona.filter(z => z.ZonaId == 1017);
              reg[0].sucursales.push(i)
              break;
            case 12:
              reg = this.dataZona.filter(z => z.ZonaId == 1019);
              reg[0].sucursales.push(i)
              break;
            default: break;
          }
        }        
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async FuncionSector(){
    this.sector.InstitucionId = this.idInstitucion;
    try{
      const res = await firstValueFrom(this.sectorService.getByAddUrl_Riesgo('sector',this.sector)); 
      var aux = [];
      for(let p of res){
        aux.push(p);
      }
      this.sectors = aux;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async FuncionAsesor(){
    this.asesor.InstitucionId = this.idInstitucion;
    try{
      const res = await firstValueFrom(this.asesorService.getByAddUrl_Riesgo('asesor',this.asesor));
      var aux = [];
      for(let p of res){
        aux.push(p);
      }
      aux.sort((a,b) => {
        if (a.Nombre_Asesor === '') return 1;
        if (b.Nombre_Asesor === '') return -1;
        return 0;
      })
      this.dataAsesor = aux;
      this.dataAsesorFiltrados = [...this.dataAsesor];
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  filtrarAsesores(event: any) {
    const valor = event.target.value.toLowerCase();

    this.dataAsesorFiltrados = this.dataAsesor.filter(asesor =>
      (asesor.Nombre_Asesor || '')
        .toLowerCase()
        .includes(valor)
    );
  }

}
